import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1C1D1D',
        accent: '#e2edef',
        background: '#FAFAFA',
      },
    },
    options: {
      customProperties: true,
    },
  },
});
